import axios from "axios";
import {db_url} from "../url";

const DB_OperationTypes = (token) => {

    const add_url = '/dictionary/operation_types'
    const get = (controller, search) => {
        return axios.get(db_url + add_url, {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const update = (data) => {
        return axios.post(db_url +add_url , data,{
            headers: {
                Authorization: token
            }
        })
    }

    const status = (id) => {
        return axios.put(db_url + add_url, null, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const setDefault = (id) => {
        return axios.patch(db_url + add_url, null, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    return {
        get,
        update,
        setDefault,
        status
    }
}

export default DB_OperationTypes